module.exports = __webpack_public_path__ + "static/media/mail icon.ede814de.svg";